import cn from 'classnames'
import React from 'react'
import { useForm } from 'react-hook-form'
import styles from './Chat.module.scss'

type TMessageProps = {
    author: string
    text: string
    isUserMessage?: boolean
}

export const Message: React.FC<TMessageProps> = ({ isUserMessage = false, author, text }) => {
    return (
        <div
            className={cn(styles.message, {
                [styles.messageSelected]: isUserMessage
            })}
        >
            <h5 className={styles.messageAuthor}>{author}</h5>
            <p className={styles.messageText}>{text}</p>
        </div>
    )
}

type TFieldProps = {
    onMessageSend: (text: string) => void
}

type TFieldForm = {
    text: string
}

export const Field: React.FC<TFieldProps> = ({ onMessageSend }) => {
    const { register, handleSubmit, reset, formState } = useForm<TFieldForm>()

    const onSubmit = (data: TFieldForm) => {
        onMessageSend(data.text)
        reset()
    }

    return (
        <div className={styles.fieldContainer}>
            <form
                className={styles.fieldForm}
                onSubmit={handleSubmit(onSubmit)}
            >
                <input
                    className={styles.fieldInput}
                    type='text'
                    placeholder='Оставить комментарий'
                    {...register('text', {
                        required: true
                    })}
                />
                <button
                    type='submit'
                    className={styles.fieldButton}
                >
                    <svg
                        width='28'
                        height='28'
                        viewBox='0 0 28 28'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                    >
                        <circle
                            cx='14'
                            cy='14'
                            r='13.5625'
                            fill='#BCCEF5'
                            fill-opacity='0.1'
                            stroke='#BCCEF5'
                            stroke-width='0.875'
                        />
                    </svg>
                    <div className={styles.fieldButtonArrow}>
                        <svg
                            width='14'
                            height='14'
                            viewBox='0 0 14 14'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M5.25 13.125L10.4512 7.05694C10.4793 7.02418 10.4793 6.97582 10.4512 6.94306L5.25 0.875'
                                stroke='#83A3EB'
                                strokeWidth='1.75'
                                strokeLinecap='round'
                            />
                        </svg>
                    </div>
                </button>
            </form>
        </div>
    )
}
